import React, { Component } from 'react';
import Checkbox from 'material-ui/Checkbox';
import * as Colors from '../../utils/Color';

const styles = {
    labelStyles: {
        fontWeight: "bold",
        marginLeft: "7px",
        fontSize: "14px",
        width: "100%",
    },
    uncheckedIconColor: {
        fill: Colors.primary,
        marginRight: 0
    },
    parentElement: {
        width: null,
        display: 'block'
    }
};

class CheckboxElement extends Component {
    render() {
        return (
            <Checkbox
                name={this.props.name}
                label={this.props.label}
                checked={this.props.value}
                onCheck={(e, isInputChecked) => this.props.onChange(this.props.name, isInputChecked)}
                style={styles.parentElement}
                labelStyle={styles.labelStyles}
                iconStyle={styles.uncheckedIconColor}
            />
        );
    }

}


export default CheckboxElement;



// WEBPACK FOOTER //
// ./src/components/UI/CheckboxField.js